import PropTypes from 'prop-types'
import { positionPropType } from '../common/position-prop-type'

/**
 * @typedef {Object} StpParking
 *
 * @property {string}  [id]           - Secure Truck Parking id
 * @property {string}  [name]         - Secure Truck Parking name
 * @property {string}  [status]       - Secure Truck Parking status
 * @property {Position}  [position]   - Coordinates of the parking
 */
export const stpParkingPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    status: PropTypes.string,
    position: positionPropType
})
